
export default {
    props: {
        title: String,
        list: Array
    }
}
